import { createI18n } from 'vue-i18n'
import tr from '../config/tr.json'
import en from '../config/en.json'

const messages = {
  tr,
  en
}

// Varsayılan dil
const defaultLocale = 'tr'

// Desteklenen diller
const supportedLocales = ['tr', 'en']

// Her zaman Türkçe ile başla
function getInitialLocale() {
  return defaultLocale
}

// localStorage'dan dil tercihini al (sadece kullanıcı manuel değiştirdiyse)
function getStoredLocale() {
  return localStorage.getItem('selectedLanguage') || getInitialLocale()
}

const i18n = createI18n({
  legacy: false, // Vue 3 için gerekli
  locale: getStoredLocale(),
  fallbackLocale: defaultLocale,
  messages,
  globalInjection: true,
  silentTranslationWarn: false
})

export default i18n 